export class StaffBasic {

    private active: string;
    private centerInternalId: string;
    private centerName: string;
    private firstname: string;
    private internalId: string;
    private lastname: string;
    private password: string;
    private userImage: string;
    private userImageName: string;
    private userImageRaw: string;
    private email: string;

    constructor(userImage?: string, firstname?: string, internalId?: string, lastname?: string, password?: string, email?: string, centerInternalId?: string, centerName?: string) { }

    public get Active() {
        return this.active;
    }
    public get CenterInternalId() {
        return this.centerInternalId;
    }
    public get CenterName() {
        return this.centerName;
    }
    public get Firstname() {
        return this.firstname;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get Lastname() {
        return this.lastname;
    }
    public get Password() {
        return this.password;
    }
    public get UserImage() {
        return this.userImage;
    }
    public get UserImageName() {
        return this.userImageName;
    }
    public get UserImageRaw() {
        return this.userImageRaw;
    }
    public get Email() {
        return this.email;
    }
    public set Active(active) {
        this.active = active;
    }
    public set CenterName(centerName) {
        this.centerName = centerName;
    }
    public set CenterInternalId(centerInternalId) {
        this.centerInternalId = centerInternalId;
    }
    public set Firstname(firstname) {
        this.firstname = firstname;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set Lastname(lastname) {
        this.lastname = lastname;
    }
    public set Password(password) {
        this.password = password;
    }
    public set UserImage(userImage) {
        this.userImage = userImage;
    }
    public set UserImageName(userImageName) {
        this.userImageName = userImageName;
    }
    public set UserImageRaw(userImageRaw) {
        this.userImageRaw = userImageRaw;
    }
    public set Email(email) {
        this.email = email;
    }
}
